export default {"src":"/_next/static/media/KG3.e392aef1.svg","height":200,"width":200,"blurWidth":0,"blurHeight":0};